import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const CANONICAL_ORIGIN = "https://my-health-directory.com";

/**
 * Emits a <link rel="canonical"> tag pointing to the canonical
 * (HTTPS, non-www) version of the current URL on every route.
 *
 * Page-level <Helmet> blocks that include their own <link rel="canonical">
 * will override this default thanks to react-helmet-async's tag de-duping
 * by `rel`+`href` precedence (last one wins per render tree).
 */
const CanonicalTag = () => {
  const { pathname, search } = useLocation();
  // Strip trailing slash (except for root) for consistency.
  const cleanPath =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;
  const href = `${CANONICAL_ORIGIN}${cleanPath}${search}`;

  return (
    <Helmet>
      <link rel="canonical" href={href} />
    </Helmet>
  );
};

export default CanonicalTag;
